<div class="employee-training-detail-container">
  <div class="header-section">
    <button mat-icon-button (click)="goBack()" class="back-button">
      <mat-icon>arrow_back</mat-icon>
      <span class="back-text">Back to Dashboard</span>
    </button>
    <button
      *ngIf="enrollment && areAllActivitiesCompleted() && canSignOff"
      mat-raised-button
      color="primary"
      class="complete-course-button header-complete-btn"
      (click)="completeEnrollment()">
      Complete Course
    </button>
  </div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Loading...</p>
  </div>

  <div *ngIf="!loading && enrollment" class="detail-content">
    <!-- Employee Summary Section -->
    <section class="employee-summary-section">
      <div class="employee-header-info">
        <div class="employee-name-section">
          <h1 class="employee-name">
            {{ enrollment.employee_name || "Employee Training" }}
          </h1>
          <div class="training-level-display">
            <mat-icon class="graduation-icon-small">school</mat-icon>
            <span
              >Training Level:
              {{ formatTrainingLevel(enrollment.training_level) }}</span
            >
          </div>
        </div>
        <div class="badge-container">
          <span class="badge active-badge">Active Training</span>
        </div>
      </div>

      <!-- Current Course Section -->
      <div class="current-course-card">
        <div class="current-course-card-header">
          <h2 class="section-title">Current Course</h2>
          <span class="progress-percentage"
            >{{ enrollment.progress_pct }}%</span
          >
        </div>
        <p class="course-name">{{ enrollment.course_name }}</p>
        <div class="progress-section-inline">
          <div class="progress-bar-training-container-inline">
            <div
              class="progress-bar-training-inline"
              [ngStyle]="getProgressBarStyle(enrollment.progress_pct)"
              style="
                background-color: #424242 !important;
                background: #424242 !important;
              "
            ></div>
          </div>
        </div>
      </div>

      <!-- Training Activities Progress -->
      <div class="activities-progress-summary">
        <div class="current-course-card-header">
          <h2 class="section-title">Training Activities Progress</h2>
          <p class="progress-text">
            {{ getCompletedCount() }} of {{ getTotalTrackedCount() }} completed
          </p>
        </div>
        <div class="activities-progress-content">
          <div class="activities-progress-bar-training-container">
            <div
              class="activities-progress-bar-training"
              [ngStyle]="getProgressBarStyle(getActivitiesProgressPct())"
              style="
                background-color: #424242 !important;
                background: #424242 !important;
              "
            ></div>
          </div>
        </div>
      </div>
    </section>

    <!-- Training Activities Table Section -->
    <section class="activities-section">
      <h2 class="section-title">Training Activities</h2>
      <div class="activities-table-container">
        <table class="activities-table">
          <thead>
            <tr>
              <th>Training Activity</th>
              <th>Initials</th>
              <th>Sign Off</th>
              <th>Sign-off by</th>
              <th>Timeline (Days)</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let activity of enrollment.activities"
              class="activity-row"
              [class.locked]="isActivityLockedForUser(activity)"
              [class.completed]="activity.is_complete"
            >
              <td class="activity-title-cell">
                <span *ngIf="isActivityLockedForUser(activity)" class="lock-icon">🔒</span>
                <span [innerHTML]="activity.description"></span>
              </td>
              <td class="initials-cell">
                <input
                  type="text"
                  class="initials-input"
                  [value]="activity.initials || 'XX'"
                  [disabled]="true"
                  readonly
                  maxlength="10"
                />
              </td>
              <td class="signoff-cell">
                <mat-checkbox
                  [checked]="activity.is_complete"
                  [disabled]="!canSignOff || !canSignOffActivity(activity) || isActivityLockedForUser(activity) || processingSignOff"
                  (change)="toggleSignOff(activity, $event)"
                  [matTooltip]="!canSignOffActivity(activity) && activity.signoff_role_name ? 'Required role: ' + activity.signoff_role_name : null"
                >
                </mat-checkbox>
              </td>
              <td class="role-cell">{{ activity.signoff_role_code || '—' }}</td>
              <td class="timeline-cell">
                <span *ngIf="isActivityLockedForUser(activity)" class="lock-icon">🔒</span>
                {{ getTimelineLabel(activity) || "Day 0" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</div>
